import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api } from "../lib/api";
import LogoImage from "../components/LogoImage";

export default function Latest() {
    const [items, setItems] = useState([]);

    useEffect(() => {
        api.getRecent(40).then(setItems);
    }, []);

    return (
        <div className="max-w-5xl mx-auto px-4 lg:px-6 py-12" data-testid="latest-page">
            <h1 className="font-heading font-extrabold text-4xl sm:text-5xl tracking-tight text-ink">
                Latest additions
            </h1>
            <p className="mt-3 text-ink-muted text-lg">
                The most recently added Indian alternatives.
            </p>

            <div className="mt-8 bg-white border border-line rounded-2xl divide-y divide-line">
                {items.map((p) => (
                    <Link
                        key={p.id}
                        to={`/product/${p.slug}`}
                        className="flex items-center gap-4 px-4 sm:px-6 py-4 hover:bg-cream"
                        data-testid={`latest-${p.slug}`}
                    >
                        <LogoImage
                            src={p.logo_url}
                            domain={p.domain}
                            name={p.name}
                            size={40}
                            rounded="rounded-lg"
                        />
                        <div className="flex-1 min-w-0">
                            <div className="font-semibold text-ink truncate">
                                {p.name}
                            </div>
                            <div className="text-xs text-ink-muted truncate">
                                {p.category_name}
                            </div>
                        </div>
                        <ArrowRight className="h-4 w-4 text-ink-muted" />
                    </Link>
                ))}
            </div>
        </div>
    );
}
